function NewProductsNavController(newProductsService) {
    this.newProducts = newProductsService;
}

module.exports = function () {
    return {
        restrict: 'E',
        scope: {},
        bindToController: true,
        controllerAs: 'newNavCtrl',
        controller: ['NewProductsService', NewProductsNavController],
        template: require('./newproducts-navigation.directive.html').trim(),
    };
};



// WEBPACK FOOTER //
// ./src/shop/newproducts/newproducts-navigation.directive.js